import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withStyles } from '@material-ui/core/styles';
import * as orderActions from '../Actions/orderActions';
import * as projectActions from '../Actions/projectActions';
import * as userActions from '../Actions/userActions';
import * as customerActions from '../Actions/customerActions';
import * as processingOrdersActions from '../Actions/processingOrdersActions';
import * as languageActions from '../Actions/languageActions';
import * as globalUIActions from '../Actions/globalUIActions';
import OrderList from "../Components/Orders/OrderList";
import { orderService } from "../Services/OrderService.js";
import {searchFilterService} from "../Services/SearchFilterService.js";
import { normalize } from 'normalizr';
import { orderSchema, userSchema } from '../Schemas/OrderSchema.js';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { userService } from "../Services/UserService.js";

const styles = theme => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
  },
});

class OrderListContainer extends Component {
	constructor(props){
		super(props);
		this.sendOdooAction = this.sendOdooAction.bind(this);
		this.checkPending = this.checkPending.bind(this);
		this.cercaResponsable = this.cercaResponsable.bind(this);
		this.deleteOrder = this.deleteOrder.bind(this);
		this.unlockOrder = this.unlockOrder.bind(this);
		this.orderQaAction = this.orderQaAction.bind(this);
		this.sendMessage = this.sendMessage.bind(this);
		this.fetchOrderRecords = this.fetchOrderRecords.bind(this);
		this.setPage = this.setPage.bind(this);
		this.setRowsPerPage = this.setRowsPerPage.bind(this);
		this.fetchUserRecords = this.fetchUserRecords.bind(this);
		
		this.isLoading = true;
		this.error = 0;
	}
	
	componentDidMount() {
//		console.log("componentDidMount");
		this.props.actions.setProcessing(1);
		orderService.listOrders(this.props.globalUI.page, this.props.globalUI.rowsPerPage, this.props.search)
					//.then(response => {this.fetchOrderRecords(response.data); this.props.actions.setProcessing(0); return true;}) //; 
					.then(response => {return this.fetchOrderRecords(response.data)}) //; this.props.actions.setProcessing(0)
					.then(projects => {return orderService.listProjectHeaders(projects)})
					.then(response => {this.props.actions.fetchProjectHeaderRecords(response.data); this.props.actions.setProcessing(0); return true;})
					.then(response => { if(this.props.user.role==='ADMIN'){
											userService.listUsers().then(response => { return this.fetchUserRecords(response.data) });
											return 1;
										}else{
											return 1;
										}
										return true;})
					.catch(err => {this.error=1});
	}
	
	fetchOrderRecords(responseData){
//		console.log("OrderListContainer:");
//		console.log("responseData:");
//		console.log(responseData);
//		console.log("normalizedData:");
		this.isLoading = false;
		if(Array.isArray(responseData) && responseData.length>0){
			var normalizedData = normalize(responseData, [orderSchema]);
//			console.log(normalizedData);
			this.props.actions.fetchOrderRecords(normalizedData.entities.orders);
			this.props.actions.fetchUserRecords(normalizedData.entities.users);
			this.props.actions.fetchCustomerRecords(normalizedData.entities.customers);
			this.props.actions.fetchLanguagePairs(normalizedData.entities.languagePairs);
			//return Object.values(normalizedData.entities.orders).reduce(function(previousValue, currentValue, index, array) {return (array[index].state=='preprocess' ? previousValue+1 : previousValue);}, 0);
			//return 1;
			//let projectSet = [...new Set (normalizedData.entities.orders.filter(order => order.projectId))];
			let projects = Object.entries(normalizedData.entities.orders).map(order => order[1].projectId);//.filter(order => {console.log(order.projectId); return order.projectId});
			return projects;
		}else{
			this.props.actions.fetchOrderRecords(new Array(0));
		}
		return null;
	}
	
	fetchUserRecords(responseData){
//		console.log("fetchUserRecords");
		var normalizedData = normalize(responseData, [userSchema]);
		this.props.actions.fetchUserRecords(normalizedData.entities.users);
		return 1;
	}
	
	setPage(page){
		this.isLoading = true;
		this.props.actions.setOrderListPage(page)
		this.props.actions.setProcessing(1);
		orderService.listOrders(page, this.props.globalUI.rowsPerPage, this.props.search)
			.then(response => {return this.fetchOrderRecords(response.data)}) //; this.props.actions.setProcessing(0)
			.then(projects => {return orderService.listProjectHeaders(projects)})
			.then(response => {this.props.actions.fetchProjectHeaderRecords(response.data); this.props.actions.setProcessing(0); return true;})
			.catch(err => {/*console.log(err);*/});
		//this.timer = setInterval(this.checkPending.bind(this), 30000);
	}
	
	setRowsPerPage(rpp){
		this.isLoading = true;
		this.props.actions.setOrderListRowsPerPage(rpp);
		this.props.actions.setProcessing(1);
		orderService.listOrders(this.props.globalUI.page, rpp, this.props.search)
			.then(response => {return this.fetchOrderRecords(response.data)}) //; this.props.actions.setProcessing(0)
			.then(projects => {return orderService.listProjectHeaders(projects)})
			.then(response => {this.props.actions.fetchProjectHeaderRecords(response.data); this.props.actions.setProcessing(0); return true;})
			.catch(err => {/*console.log(err);*/});
		//this.timer = setInterval(this.checkPending.bind(this), 30000);
	}
	
	orderQaAction(orderId, task, qaOK){
		this.isLoading = true;
		orderService.qaOrderTask(orderId, task, this.props.user.access_token, qaOK)
					.then(response => { return orderService.listOrders(this.props.globalUI.page, this.props.globalUI.rowsPerPage, this.props.search)})
					.then(response => {return this.fetchOrderRecords(response.data)})
					.catch(err => {/*console.log(err);*/});
	}
	sendOdooAction(orderId, task, state){
		this.isLoading = true;
		orderService.sendOdoo(orderId, this.props.user.access_token)
					.then(response => { return orderService.listOrders(this.props.globalUI.page, this.props.globalUI.rowsPerPage, this.props.search)})
					.then(response => {return this.fetchOrderRecords(response.data)})
					.catch(err => {/*console.log(err);*/});
	}
	
	checkPending(){
//		console.log("checkPending orders ("+this.props.processingOrders+")");
		//if(this.props.processingOrders){
		if(this.props.globalUI.processing===0){
			//clearInterval(this.timer);
			this.props.actions.setProcessing(1)
			orderService.listOrders(this.props.globalUI.page, this.props.globalUI.rowsPerPage, this.props.search)
					.then(response => {this.fetchOrderRecords(response.data); this.props.actions.setProcessing(0); return true;})
					.catch(err => {/*console.log(err);*/});
		}
	}
	
	deleteOrder(orderId){
		this.isLoading = true;
		orderService.deleteOrder(orderId, this.props.user.access_token)
					.then(response => { return orderService.listOrders(this.props.globalUI.page, this.props.globalUI.rowsPerPage, this.props.search)})
					.then(response => {return this.fetchOrderRecords(response.data)})
					.catch(err => {/*console.log(err);*/});
	}
	
	unlockOrder(orderId){
		this.isLoading = true;
		orderService.unlockOrder(orderId)
					.then(response => { return orderService.listOrders(this.props.globalUI.page, this.props.globalUI.rowsPerPage, this.props.search)})
					.then(response => {return this.fetchOrderRecords(response.data)})
					.catch(err => {/*console.log(err);*/});
	}
	
	cercaResponsable(acum, value){
		if(value.type=="TRANSLATION" || value.type=="PROOF_PRINTING" || value.type=="REVISION"){
			if(value.user!==null){
				acum.push(value.user.username.toLowerCase());
				//acum=value.user.username.toLowerCase();
			}
		}
		return acum;
	}
	
	sendMessage(orderId, message){
		this.isLoading = true;
		orderService.sendMessage(orderId, message)
					.then(response => { return orderService.listOrders(this.props.globalUI.page, this.props.globalUI.rowsPerPage, this.props.search)})
					.then(response => {return this.fetchOrderRecords(response.data)})
					.catch(err => {/*console.log(err);*/});
	}
	
	render(){
//		console.log("orderRecords RENDER");
//		console.log(this.props.orderRecords);
//		console.log(this.props.projectRecords);
//		console.log("this.props.globalUI:");
//		console.log(this.props.globalUI);
		if(this.error>0) return (<div>Error!</div>);
	    return (<div>
				<Backdrop
					className={this.props.classes.backdrop}
					open={this.isLoading}
				>
					<CircularProgress color="inherit" />
				</Backdrop>
				<OrderList	orders={this.props.orderRecords}
							projects={this.props.projectRecords}
							users={this.props.userRecords}
							customers={this.props.customerRecords}
							langPairs={this.props.langPairs}
							orderQaAction={this.orderQaAction}
							sendOdooActions={this.sendOdooAction}
							deleteOrder={this.deleteOrder}
							unlockOrder={this.unlockOrder}
							accessToken={this.props.user.access_token}
							userName={this.props.user.username}
							userRole={this.props.user.role}
							viewTranslators={!(this.props.user.role=='CUSTOMER' && !this.props.user.customer.seeSuppliers)}
							sendMessage={this.sendMessage}
							page={(typeof this.props.globalUI.page !== 'undefined')?this.props.globalUI.page:0}
							rowsPerPage={(typeof this.props.globalUI.rowsPerPage !== 'undefined')?this.props.globalUI.rowsPerPage:25}
							setPage={this.setPage}
							setRowsPerPage={this.setRowsPerPage}/>
				</div>
				);
	}
}

function mapStateToProps(state, ownProps) {
	//console.log("state OL:");
	//console.log(state);	
	return {orderRecords: state.orders, projectRecords: state.projects, userRecords: state.users, customerRecords: state.customers, langPairs: state.languagePairs, user: state.user, search: state.search, processingOrders: state.processingOrders, globalUI: state.globalUI}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(Object.assign({}, orderActions, projectActions, userActions, customerActions, languageActions, processingOrdersActions, globalUIActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrderListContainer))